import { Box, Button, Grid, TextField, MenuItem } from '@mui/material';
import { useEffect, useState } from 'react';

const METODOS = ['Efectivo', 'Transferencia', 'QR', 'Tarjeta'];

export default function VentaForm({ onSubmit, editing }) {
  const [form, setForm] = useState({
    fecha: '',
    cliente: '',
    concepto: '',
    monto: '',
    metodoPago: 'Efectivo',
    nroFactura: ''
  });

  useEffect(() => {
    if (editing) setForm(editing);
  }, [editing]);

  const handleChange = e =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = () => {
    if (!form.monto || !form.cliente) {
      alert('Cliente y monto son obligatorios');
      return;
    }
    onSubmit(form);
    setForm({
      fecha: '',
      cliente: '',
      concepto: '',
      monto: '',
      metodoPago: 'Efectivo',
      nroFactura: ''
    });
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            type="date"
            label="Fecha"
            name="fecha"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={form.fecha}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Cliente"
            name="cliente"
            fullWidth
            value={form.cliente}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Concepto"
            name="concepto"
            fullWidth
            value={form.concepto}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Monto"
            name="monto"
            type="number"
            fullWidth
            value={form.monto}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            select
            label="Método de Pago"
            name="metodoPago"
            fullWidth
            value={form.metodoPago}
            onChange={handleChange}
          >
            {METODOS.map(m => (
              <MenuItem key={m} value={m}>{m}</MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Nro Factura (opcional)"
            name="nroFactura"
            fullWidth
            value={form.nroFactura}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 2 }}
        onClick={handleSubmit}
      >
        {editing ? 'Actualizar Venta' : 'Registrar Venta'}
      </Button>
    </Box>
  );
}
